<template>
  <div class="page">
    <query-form label-width="90px">
      <template v-slot:formitem>
        <query-form-item :label="$t('wholesaleOrder.orderTime')">
          <el-date-picker
            v-model="daterange"
            type="daterange"
            value-format="timestamp"
            :default-time="['00:00:00', '23:59:59']"
            style="width: 100%"
            :clearable="true"
          >
          </el-date-picker>
        </query-form-item>
        <query-form-item :label="$t('common.orderLineNo')" label-width="110px">
          <el-input clearable v-model="queryForm.wholesaleMergeNo"></el-input>
        </query-form-item>
      </template>
      <template>
        <el-button class="mb10" type="primary" @click="search">{{ $t('common.search') }}</el-button>
        <el-button class="mb20" type="info" @click="reset">{{ $t('common.reset') }}</el-button>
      </template>
    </query-form>

    <el-table class="spacing-table" v-loading="loading" :data="tableData">
      <el-table-column prop="wholesaleMergeNo" :label="$t('common.orderLineNo')"></el-table-column>
      <el-table-column prop="createAt" :label="$t('wholesaleOrder.orderTime')">
        <template slot-scope="scope">{{ scope.row.createAt | dateFormat('yyyy-MM-dd HH:mm') }}</template>
      </el-table-column>
      <el-table-column prop="totalQuantity" :label="$t('common.qty')"></el-table-column>
      <el-table-column prop="totalAmount" :label="$t('order.totalAmount')"></el-table-column>
      <el-table-column prop="merchantRequireAmount" :label="$t('wholesaleOrder.minimumPuchaseAmount')"></el-table-column>
      <el-table-column prop="hotProductRatio" :label="$t('wholesaleOrder.hotItemProportion')"></el-table-column>
      <el-table-column prop="merchantRequireRatio" :label="$t('wholesaleOrder.hotItemProportionOfOrder')"></el-table-column>
      <el-table-column prop="shippedStatus" :label="$t('wholesaleOrder.shippingStatus')">
        <template slot-scope="scope">
          <span v-if="scope.row.shippedStatus === 0">{{ $t('wholesaleOrder.notShipped') }}</span>
          <span v-if="scope.row.shippedStatus === 1">{{ $t('wholesaleOrder.partialShipment') }}</span>
          <span v-if="scope.row.shippedStatus === 2">{{ $t('wholesaleOrder.shipAll') }}</span>
        </template>
      </el-table-column>
      <el-table-column width="100" label="Action">
        <template slot-scope="scope">
          <el-button type="text" @click="toDetail(scope.row)">{{ $t('openTools.detail') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNo"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
import {
  getWholesaleMergeList,
} from '../../api/wholesaleOrder';

export default {
  data() {
    return {
      loading: false,
      daterange: [],
      queryForm: {
        wholesaleMergeNo: null,
        pageNo: 1,
        pageSize: 25,
      },
      total: 0,
      tableData: [],
      selection: [],
    };
  },
  created() {
    this.getTableData();
  },
  methods: {
    search() {
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    reset() {
      this.queryForm.wholesaleMergeNo = undefined;
      this.daterange = [];
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    getTableData() {
      this.loading = true;
      getWholesaleMergeList({
        ...this.queryForm,
        startTime: this.daterange ? this.daterange[0] : null,
        endTime: this.daterange ? this.daterange[1] : null,
      }).then((res) => {
        this.total = res.data.total;
        this.tableData = res.data.list || [];
        this.loading = false;
      });
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      this.getTableData();
    },
    toDetail(row) {
      window.open(`${this.$router.options.base}/wholesaleOrder/detail/${row.wholesaleMergeNo}`);
    },
  },
};
</script>

<style lang="scss" scoped></style>
